import * as arrow from 'apache-arrow';
import { VECTOR_TYPES } from "../types.js";
export function encodeArrowSync(data) {
  const vectors = {};
  for (const arrayData of data) {
    const arrayVector = createVector(arrayData.array, arrayData.type);
    vectors[arrayData.name] = arrayVector;
  }
  const table = new arrow.Table(vectors);
  const arrowBuffer = arrow.tableToIPC(table);
  return arrowBuffer;
}
function createVector(array, type) {
  switch (type) {
    case VECTOR_TYPES.DATE:
      return arrow.vectorFromArray(array);
    case VECTOR_TYPES.FLOAT:
    default:
      return arrow.vectorFromArray(array);
  }
}
//# sourceMappingURL=encode-arrow.js.map